module.exports = __webpack_public_path__ + "img/img-11.974c15d1.png";